import { theme } from '../../../theme';

import { StyledImage, StyledPicture } from './CustomPicture.styled';
import { CustomPictureProperties } from './CustomPicture.types';
import { getAmplienceUrl } from './utils';

export function CustomPicture({
    id,
    name,
    alt = '',
    className,
    lazy = true,
    query,
}: CustomPictureProperties) {
    const { defaultUrl, mobileUrl } = getAmplienceUrl({ name, query });

    return (
        <StyledPicture id={id} className={className}>
            <source
                srcSet={defaultUrl}
                media={`(min-width: ${theme.breakpoints.values.desktop}px)`}
            />
            <source
                srcSet={mobileUrl}
                media={`(max-width: ${theme.breakpoints.values.desktop - 1}px)`}
            />
            <StyledImage
                id={id}
                src={defaultUrl}
                alt={alt}
                loading={lazy ? 'lazy' : 'eager'}
            />
        </StyledPicture>
    );
}
